import React from "react";
import { Calendar } from "primereact/calendar";
import { TimePicker } from "antd";
import { Link, useParams, useLocation, } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import {
  useSelector,
  // useDispatch
} from "react-redux";
// import { getAddressFromCoords } from "../../core/data/redux/action";
import { RootState } from "../../core/data/redux/store";
import dayjs from "dayjs";
import moment from 'moment';


const BookingCheckout = ({
  //  register,
  isSubmitted, errors, setValue, watch, nextStep, rentalTypeId
}: any) => {

  const routes = all_routes;
  // const dispatch = useDispatch<AppDispatch>();
  const { vin } = useParams();

  const { user, systemSettings, bookingTypes, bookingTotalAmount } = useSelector(
    (state: RootState) => ({
      bookingTypes: state.booking.bookingTypes,
      systemSettings: state.auth.systemSettings,
      bookingTotalAmount: state.booking.bookingTotalAmount,
      user: state.auth.user,
    })
  );


  // const getAddress = () => {
  //   dispatch(getAddressFromCoords());
  // }


  // useEffect(() => {
  //   setValue("delivery_location", location_address ?? '');
  // }, [location_address]);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const getParam = (key: string) => {
    const value = queryParams.get(key);
    return value ? decodeURIComponent(value) : "";
  };



  const minTime = moment(systemSettings?.booking_start_time, 'HH:mm');
  const maxTime = moment(systemSettings?.booking_end_time, 'HH:mm');

  // Function to disable hours outside of the range
  const disabledHours = () => {
    const hours = [];
    for (let i = 0; i < 24; i++) {
      if (i < minTime.hour() || i > maxTime.hour()) {
        hours.push(i);
      }
    }
    return hours;
  };

  // Function to disable minutes outside of the range
  const disabledMinutes = (hour: any) => {
    if (hour === minTime.hour()) {
      return Array.from({ length: minTime.minute() }).map((_, index) => index);
    }
    if (hour === maxTime.hour()) {
      return Array.from({ length: 60 - maxTime.minute() }).map((_, index) => index);
    }
    return [];
  };

  return (
    <>
      {/*  <div className="booking-information-card">
        <div className="booking-info-head">
          <span>
            <i className="bx bxs-car-garage" />
          </span>
          <h5>Rental Type</h5>
        </div>   <div className="booking-info-body">
          <ul className="booking-radio-btns">
            
            <li>
              <label className="booking_custom_check">
                <input
                  type="radio"
                  className={`form-control mb-0 ${errors.rental_type ? "is-invalid" : ""}`}
                  value="self pickup"
                  {...register("rental_type", { required: "Rental type is required" })}
                />
                <span className="booking_checkmark">
                  <span className="checked-title">Self Pickup</span>
                </span>
              </label>
            </li>
            <li>
              <label className="booking_custom_check">
                <input
                  type="radio"
                  className={`form-control mb-0 ${errors?.rental_type ? "is-invalid" : ""}`}
                  value="delivery"
                  {...register("rental_type", { required: "Rental type is required" })}
                  defaultChecked
                />
                <span className="booking_checkmark">
                  <span className="checked-title">Delivery</span>
                </span>
              </label>
            </li>
          </ul>


        </div> 
      </div>*/}



      <div className="booking-information-card booking-type-card mb-0  d-none d-md-block">
        <div className="booking-info-head">
          {/* <span>
            <i className="bx bx-calender" />
          </span> */}
          <h5>Trip Date & Time</h5>
        </div>



        <div className="booking-info-body">
          {/* <ul className="booking-radio-btns">
              <li>
                <label className="booking_custom_check">
                  <input
                    type="radio"
                    name="booking_type"
                    value="day"
                    defaultChecked
                    {...register("booking_type", { required: "Booking type is required" })}
                  />
                  <span className="booking_checkmark">
                    <span className="checked-title">
                      Day
                    </span>
                  </span>
                </label>
              </li>
              <li>
                <label className="booking_custom_check">
                  <input type="radio" name="booking_type" value="week"
                    {...register("booking_type", { required: "Booking type is required" })} />
                  <span className="booking_checkmark">
                    <span className="checked-title">Weekly</span>
                  </span>
                </label>
              </li>
              <li>
                <label className="booking_custom_check">
                  <input type="radio" name="booking_type" value="month"
                    {...register("booking_type", { required: "Booking type is required" })} />
                  <span className="booking_checkmark">
                    <span className="checked-title">Monthly</span>
                  </span>
                </label>
              </li>
            </ul> */}

          {/* <ul className="booking-radio-btns">
            {bookingTypes?.map((method, index) => {
              return (

                <li key={index}>
                  <label className="booking_custom_check">
                    <input
                      type="radio"
                      name="rental_type_id"
                      value={method.id}
                      checked={method.id === watch("rental_type_id")}
                      onChange={() =>
                        setValue("rental_type_id", method.id)
                      }
                    />
                    <span className="booking_checkmark">
                      <span className="checked-title">
                        {method.name}
                      </span>
                    </span>
                  </label>
                </li>

              )
            })}
          </ul> */}


          <div className="row">
            <div className="col-6">
              <div className="input-block date-widget">
                <label className="form-label">Start Date</label>
                <div className="group-img">
                  <Calendar
                    minDate={new Date()}
                    invalid={isSubmitted && errors.booking_start_date}
                    className="  "
                    disabled={getParam("token") ? true : false}
                    value={watch("booking_start_date") ? new Date(watch("booking_start_date")) : null} // Ensure value is a Date object
                    onChange={(e) => {
                      const formattedDate = e.value ? dayjs(e.value).format("YYYY-MM-DD") : "";

                      if (e.value) {
                        const min = bookingTypes?.filter((item: any) => item?.id === rentalTypeId)[0]?.min_duration - 1 || 0;
                        const endDate = dayjs(formattedDate).add(min, 'day').format("YYYY-MM-DD");
                        setValue("booking_start_date", formattedDate);
                        setValue("booking_return_date", endDate); // Ensures consistent format
                      }
                    }}

                    placeholder="Choose Date"
                  />
                  <span className="input-cal-icon">
                    <i className="bx bx-calendar" />
                  </span>
                </div>
              </div>
            </div>
            <div className="col-6">
              <div className="input-block time-widge">
                <label className="form-label">Start Time </label>
                <div className="group-img style-custom">

                  <TimePicker
                    disabled={getParam("token") ? true : false}
                    status={isSubmitted && errors.booking_start_time ? "error" : ""}
                    placeholder="Choose Time"
                    className={`form-control timepicker`}
                    value={watch("booking_start_time") ? dayjs(watch("booking_start_time"), "HH:mm") : null} // Ensure value is valid
                    onChange={(time) => {
                      const formattedTime = time ? time.format("HH:mm") : ""; // Store as HH:mm format
                      setValue("booking_start_time", formattedTime, { shouldValidate: true });
                    }}
                    format="HH:mm"
                    disabledHours={disabledHours}
                    disabledMinutes={disabledMinutes}
                  />

                  <span className="input-cal-icon">
                    <i className="bx bx-time" />
                  </span>
                </div>
              </div>
            </div>
            <div className="col-6">
              <div className="input-block date-widget">
                <label className="form-label">
                  Return Date
                </label>
                <div className="group-img">
                  <Calendar
                    disabled={getParam("token") ? true : false}
                    invalid={isSubmitted && errors.booking_return_date}
                    minDate={(() => {
                      const startDate = new Date(watch("booking_start_date"));
                      const min = bookingTypes?.filter((item: any) => item?.id === rentalTypeId)[0]?.min_duration || 1
                      startDate.setDate(startDate.getDate() + min);
                      return startDate;
                    })()}

                    className=" "
                    value={watch("booking_return_date") ? new Date(watch("booking_return_date")) : null} // Ensure value is a Date object
                    onChange={(e) => {
                      const formattedDate = e.value ? dayjs(e.value).format("YYYY-MM-DD") : "";
                      setValue("booking_return_date", formattedDate); // Store formatted date
                    }}
                    placeholder="Choose Date"
                  />

                  <span className="input-cal-icon">
                    <i className="bx bx-calendar" />
                  </span>
                </div>
              </div>
            </div>
            <div className="col-6">
              <div className="input-block time-widge">
                <label className="form-label">
                  Return Time
                </label>
                <div className="group-img style-custom">

                  <TimePicker
                    disabled={getParam("token") ? true : false}
                    status={isSubmitted && errors.booking_return_time ? "error" : ""}
                    placeholder="Choose Time"
                    className={`form-control timepicker ${errors.booking_return_time ? "is-invalid" : ""}`}

                    value={watch("booking_return_time") ? dayjs(watch("booking_return_time"), "HH:mm") : null}
                    onChange={(time) => {
                      const formattedTime = time ? dayjs(time).format("HH:mm") : "";
                      setValue("booking_return_time", formattedTime, { shouldValidate: true });
                    }}
                    format="HH:mm"
                    disabledHours={disabledHours}
                    disabledMinutes={disabledMinutes}
                  />

                  <span className="input-cal-icon">
                    <i className="bx bx-time" />
                  </span>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>



      <div className="booking-info-btns d-none  d-md-flex  justify-content-end ">

       

        {user?.id ?
          bookingTotalAmount?.total && <button type="submit"
            onClick={nextStep}
            className="btn btn-primary me-1 mt-1">
            Continue Booking
          </button>

          :
          <button type="button"
            data-bs-toggle="modal" data-bs-target="#login"
            className="btn btn-primary me-1 mt-1">
            Continue Booking
          </button>

        }

        <Link
          to={`${routes.listingDetails}/${vin}`} className="btn btn-secondary mt-1"   >
          Back to Car Details
        </Link>


      </div>

    </>
  );
};

export default BookingCheckout;
